import { ChangeDetectionStrategy, Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionPreviewHeaderSection } from '../../../../../services/gable/gable.service';

/**
 * `header` section of an action-preview card: title + subtitle on the left,
 * status chip pinned right. Matches the Figma's "Create violation for N
 * units? / Pending" row (node 1391:21268).
 */
@Component({
    selector: 'app-ap-header-section',
    templateUrl: './header-section.component.html',
    styleUrls: ['./header-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActionPreviewHeaderSectionComponent {
    chipColor(tone?: string): 'gray' | 'blue' | 'green' | 'orange' | 'red' {
        return tone === 'primary' ? 'blue' : tone === 'success' ? 'green' : tone === 'warning' ? 'orange' : tone === 'danger' ? 'red' : 'gray';
    }

    @Input({ required: true }) section!: ActionPreviewHeaderSection;

    /** Muted scale line under the title ("194 units") for bulk-target actions (SD-9212). Card computes it; null when the preview has no target count. */
    @Input() scaleLine: string | null = null;
}
